import { render, staticRenderFns } from "./LogotypeBand.vue?vue&type=template&id=1918513e&scoped=true"
import script from "./LogotypeBand.vue?vue&type=script&lang=js"
export * from "./LogotypeBand.vue?vue&type=script&lang=js"
import style0 from "./LogotypeBand.vue?vue&type=style&index=0&id=1918513e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918513e",
  null
  
)

export default component.exports